<template>
    <div class="orderList">
        <custom-header @clickLeft="$router.push('/mine')" :leftText="pageTitle" />
        <van-tabs swipeable v-model="active">
            <van-tab v-for="(item, index) in tabList" :key="index" :title="item.title">
                <div class="order-wrap">
                    <lazy-list v-if="showList" :api="getOrderList" :params="params" :filter="list => list.sort((a, b) => b.orderTime - a.orderTime)">
                        <template #default="{list}">
                            <OrderItem
                                v-for="(item, index) in list"
                                :key="index"
                                @click="clickOrderItem(item)"
                                :cover="item.hotelImg"
                                :roomNum="item.roomCount"
                                :status="item.status"
                                :roomCount="item.roomCount"
                                :hotelName="item.hotelName"
                                :roomName="item.room.name"
                                :hotelAddress="item.hotelAddress"
                                :startTime="item.startLiveTime"
                                :endTime="item.startLiveTime + (item.liveCount || 1) * 1000 * 60 * 60 * 24"
                                :stars="item.stars"
                                :serviceStatus="item.serviceStatus"
                            />
                        </template>
                    </lazy-list>
                </div>
            </van-tab>
        </van-tabs>
    </div>
</template>
<script>
import { getOrderList } from "@/api/hotel";
export default {
    data() {
        return {
            active: 0,
            tabList: [
                { title: "全部", status: "" },
                { title: "待处理", status: "0" },
                { title: "处理中", status: "1" },
                { title: "待出行", status: "2" },
                // { title: "预定失败", status: "-1" },
                { title: "售后", status: "-2" },
                // { title: "失效订单", status: "4" },
                // { title: "已完成", status: "3" },
            ],
            params: { status: "" },
            showList: true,
            pageTitle: "",
        };
    },
    watch: {
        active: {
            handler(newV) {
                if (newV == 0) {
                    this.params = { status: "" };
                }
                this.pageTitle = this.tabList[newV].title;
                this.params = { status: this.tabList[newV].status };
                this.showList = false;
                setTimeout(() => {
                    this.showList = true;
                });
            },
        },
    },
    created() {
        let queryIndex = Number(this.$route.query.index);
        !isNaN(queryIndex) && (this.active = queryIndex);
        this.pageTitle = this.$route.query.title;
    },
    methods: {
        getOrderList,
        clickOrderItem(item) {
            this.$router.push({ path: "/orderDetail", query: { orderId: item.id } });
        },
    },
};
</script>

<style lang="scss" scoped>
.orderList {
    /deep/.van-tab--active {
        color: $primary;
    }
    /deep/.van-tabs__line {
        background-color: #f0d9af;
    }
    .order-wrap {
        padding: 1.5vw 3vw;
        background-color: #f8f8f8;
        height: calc(100vh - 11.5vw - 46px);
        box-sizing: border-box;
        overflow-y: scroll;
    }
}
</style>
